module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"news-by-vehicle-type":"News by vehicle type"},"pt":{"news-by-vehicle-type":"Notícias por tipo de veículo"},"es":{"news-by-vehicle-type":"Noticias por tipo de vehículo"}}')
  delete Component.options._Ctor
}
